import {dateCompareDesc} from '@lib/utils';
import {createEntityAdapter} from '@reduxjs/toolkit';
import {parseISO} from 'date-fns';
import {Notification} from '../entities';

export const notificationsAdapter = createEntityAdapter<Notification>({
  selectId: (notification) => notification.id,
  sortComparer: (n1, n2) => dateCompareDesc(parseISO(n1.creationDateTime), parseISO(n2.creationDateTime)),
});
